// client/src/routes/app/my-building.tsx — SCR-BLD-004 „Clădirile mele" · D-3368, D-3911 (04 §8.21).
//
// The owner's overview of the clădiri he holds apartments in (`BuildingsOverview`): one card per
// clădire, one row per apartment, each linked apartment opening its property's „Clădire" tab. Until
// the Product Owner's ruling P2 of 2026-10-15 this route mounted the resident section the portal's
// „Clădire" tab mounts (D-1730's rule, D-3368); the portal keeps it, the console has the overview.
//
// The path is kept, so every notification written for „Clădirea mea" still lands here (D-3403), and
// `validateSearch` keeps `?ticket=`, which the overview opens by id (D-3676). The roles are the ones
// whose session opens in the console and who may live in a clădire: an owner, a co-owner, and an
// administrator whose only memberships are clădiri (D-3372).

import { createFileRoute } from '@tanstack/react-router';

import { RequireAnyRole } from '@/components/layout/route-guards';
import { MY_BUILDING_ROLES } from '@/features/buildings/my/access';
import { BuildingsOverview } from '@/features/buildings/my/BuildingsOverview';
import { myBuildingSearchSchema } from '@/features/buildings/my/search';

export const Route = createFileRoute('/app/my-building')({
  validateSearch: myBuildingSearchSchema,
  component: MyBuildingScreen,
});

function MyBuildingScreen() {
  return (
    <RequireAnyRole roles={MY_BUILDING_ROLES}>
      <BuildingsOverview />
    </RequireAnyRole>
  );
}
